module.exports = __webpack_public_path__ + "img/logo_dmdance.caa1c1cc.png";